import React from "react";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";

function FilterControl({ setSortBy, options, sortBy }) {
  return (
    <FormControl
      size="small"
      sx={{
        minWidth: 140,
        border: "none", // убираем бордер у FormControl
        "& .MuiInputBase-root": {
          border: "none !important", // убираем бордер у InputBase
          backgroundColor: "transparent", // прозрачный фон
        },
      }}
    >
      <Select
        value={sortBy || ""}
        onChange={(e) => setSortBy(e.target.value)}
        displayEmpty
        sx={{
          border: "none",
          borderRadius: "4px",
          height: 36,
          pl: 1,
          backgroundColor: "transparent",
          "&:focus": {
            border: "none",
            backgroundColor: "transparent",
          },
          "& fieldset": {
            border: "none",
          },
        }}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <Button
                disableRipple
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  padding: 0,
                  border: 0,
                  backgroundColor: "transparent",
                  textTransform: "none",
                  fontWeight: 400,
                  color: "inherit",
                }}
              >
                <Typography>Сортувати</Typography>
                <img src="/icons/sort.svg" alt="sort" />
              </Button>
            );
          }
          const selectedOption = options.find((o) => o.value === selected);
          return selectedOption?.label || "";
        }}
      >
        <MenuItem disabled value="">
          <em>Сортувати</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default FilterControl;
